module.exports = __webpack_public_path__ + "img/57_20.34fc6945.png";